<template>
    <div class="row">
        <div class="col-12 clearfix mb-3">
            <button type="button" class="btn btn-brand pull-left" @click.prevent="createNew">{{ uLang('app.add_type', { type: lang('app.type') }) }}</button>
        </div>

        <div class="col-12 document-type-type-select">
            <form-select
                name="type"
                label="type"
                :options="document_types"
                :allow-empty="false"
                :on-input="onTypeSelected"
                :loading="!document_types.length"
                track-by="id"
                ref="typeSelect"
                autocomplete="off"
                object-name-key="description"
            >
            </form-select>
        </div>

        <div class="col-12" v-if="document_types.length && (id || is_new) && !retrieving">
            <div class="row">
                <div class="col-12">
                    <form-input :form="form" type="text" name="description" required/>
                </div>

                <div class="col-12">
                    <backend-select
                        :error="form.errors.get('relation_types')"
                        :value="field('relation_types')"
                        v-model="form.relation_types"
                        :route="route('types.index')"
                        return="id"
                        name="relation_types"
                        label="visible_to"
                        multiple
                    />
                </div>

                <div class="col-12">
                    <div class="form-group">
                        <input
                            :disabled="form.busy"
                            type="button"
                            @click.prevent="store"
                            class="btn btn-brand"
                            :value="isUpdate() ? uLang('app.save') : uLang('app.add_type', { type: lang('app.type')})"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 text-center" v-if="retrieving">
            <i class="fa fa-3x fa-spin fa-circle-o-notch"></i>
        </div>
    </div>
</template>

<script>
    import Form from "~/Form/Form";
    import FormMixin from '~/mixins/form';
    import MultiSelect from 'vue-multiselect'

    export default {
        name: "form-setting-document-types",
        mixins: [FormMixin],

        components: {
            MultiSelect
        },

        props: {
            settingId: {
                required: true,
            },
        },

        data() {
            return {
                id: null,
                entity: 'document-type',
                form: new Form({
                    description: '',
                    relation_types: null,
                }),
                document_types: [],
                document_type: null,
                is_new: false,
            }
        },

        created() {
            this.retrieveDocumentTypes();

            this.$on('afterStore', data => {
                this.retrieveDocumentTypes(true, data.id);
            });
            this.$on('afterUpdate', data => {
                this.retrieveDocumentTypes(true, data.id);
            });
        },

        methods: {
            async retrieveDocumentTypes(afterSave, id) {
                let {data} = await window.axios.get(route('document-types.index'));
                this.document_types = data;

                let typeSelect = this.$refs.typeSelect;
                if (afterSave) {
                    typeSelect.model = this.document_types.find(t => t.id === id);
                    this.onTypeSelected(typeSelect.model);
                }
            },

            createNew() {
                // Show form for when item is new
                this.is_new = true;

                this.clearForm();
            },

            async clearForm() {
                // Set selected type to null
                this.$refs.typeSelect.model = null;

                // Reset the data
                this.id = null;
                this.document_type = null;
                this.form.description = '';
                this.form.relation_types = null;
            },

            onTypeSelected(val) {
                this.is_new  = false;
                if (val !== null) {
                    this.id = val.id;
                    this.document_type = val;
                    this.retrieve();
                } else {
                    this.document_type = null;
                }
            },
        },
    }
</script>
